import { createContext, version as ReactVersion } from 'react';
const ContextKey = Symbol.for(`react-redux-context-${ReactVersion}`);
const gT = globalThis;
function getContext() {
  let realContext = gT[ContextKey];
  if (!realContext) {
    realContext = /*#__PURE__*/createContext(null);
    if (process.env.NODE_ENV !== 'production') {
      realContext.displayName = 'ReactRedux';
    }
    gT[ContextKey] = realContext;
  }
  return realContext;
}
export const ReactReduxContext = /*#__PURE__*/new Proxy({}, /*#__PURE__*/new Proxy({}, {
  get(_, handler) {
    const target = getContext(); // @ts-ignore

    return function (_target) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      return Reflect[handler](target, ...args);
    };
  }
}));
export default ReactReduxContext;